import { FC, ReactElement } from 'react';
import { Modal, ModalProps } from './modal';
import './prizeModal.styl';

interface PrizeModalProps extends ModalProps {
    imgSrc?: string;
    background: string;
    title: string;
    description?: string | ReactElement;
    beforeTitleComponent?: ReactElement;
}

export const PrizeModal: FC<PrizeModalProps> = ({
    background,
    children,
    description,
    imgSrc,
    title,
    beforeTitleComponent,
    ...rest
}) => {
    return (
        <Modal view="prize" prizeParams={{ background, imgSrc }} {...rest}>
            <div className="modal-prize">
                {beforeTitleComponent}
                <span className="modal-prize-title">{title}</span>
                <span className="modal-prize-description">{description}</span>
                {children}
            </div>
        </Modal>
    );
};
